import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_MIQNAF_EFFORT_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const MiqnafEffortReport = lazy(() =>
  import('../../../screens/MiqnafEffortReport')
    .then(module => ({default: module.MiqnafEffortReport})));

const MiqnafEffortReportNavigation = [
  {
    path: ROUTE_MIQNAF_EFFORT_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <MiqnafEffortReport />
      </Suspense>
    ),
  },
];

export default MiqnafEffortReportNavigation;
